var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.88619 0.0255025 3.86614 0.876545 2.37134 2.37134C0.876545 3.86614 0.0255025 5.88619 0 8C0.0255025 10.1138 0.876545 12.1339 2.37134 13.6287C3.86614 15.1235 5.88619 15.9745 8 16C10.1138 15.9745 12.1339 15.1235 13.6287 13.6287C15.1235 12.1339 15.9745 10.1138 16 8C15.9745 5.88619 15.1235 3.86614 13.6287 2.37134C12.1339 0.876545 10.1138 0.0255025 8 0ZM12.5714 8.57143H8.57143V12.5714H7.42857V8.57143H3.42857V7.42857H7.42857V3.42857H8.57143V7.42857H12.5714V8.57143Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.0905209210d35e89f0905d9d90d6df36.svg";
export { ForwardRef as ReactComponent };